/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import "../../../css/tabViewCentered.css";
import InteractiveProposalSolutionInsights from "./ProposalSolutionSubTab.tsx/InsightsTab";
import ExperienceTab from "./ProposalSolutionSubTab.tsx/ExperienceTab";
import { THEME } from "app/utils/types";
import { getSessionStore } from "app/utils/sessionStore";
import CommentLayout from "app/uicomponents/macrocomponents/Comments/CommentLayout";
import VisualTab from "./ProposalSolutionSubTab.tsx/VisualsTab";
import { getThemeColors } from "app/utils/utils";
import VisualizeIcon from "app/assets/IconComponent/VisualizeIcon";
import WatchIcon from "app/assets/IconComponent/WatchIcon";
import UnderstandIcon from "app/assets/IconComponent/UnderstandIcon";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const VisualIconComponent = ({ isActive, fill }: { isActive: boolean; fill?: string }) => (
  <VisualizeIcon width="22" height="22" fill={fill} />
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InsightIcon = ({ isActive, fill }: { isActive: boolean; fill?: string }) => (
  <UnderstandIcon width="20" height="20" fill={fill} />
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ExperienceIconComponent = ({ isActive, fill }: { isActive: boolean; fill?: string }) => (
  <WatchIcon width="22" height="22" fill={fill} />
);
interface IInteractiveProposalSolution {
  isIntReactiveRevCent?: boolean;
}
const InteractiveProposalSolution: React.FC<IInteractiveProposalSolution> = ({
  isIntReactiveRevCent,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [globalTheme, setGlobalTheme] = useState<string>(getSessionStore("globalTheme"));
  const { branding } = getSessionStore("lookUpResponse");
  const { primaryColor, secondaryColor } = getThemeColors(branding);
  const isDarkTheme = globalTheme === THEME.DARK;
  const brandColor = isDarkTheme ? secondaryColor : primaryColor;

  useEffect(() => {
    const intervalId = setInterval(() => {
      const updatedTheme = getSessionStore("globalTheme");
      if (updatedTheme !== globalTheme) {
        setGlobalTheme(updatedTheme);
      }
    }, 200); // Check every second

    return () => {
      clearInterval(intervalId);
    };
  }, [globalTheme]);

  const tabs = [
    {
      label: "Visuals",
      icon: (isActive: boolean) => <VisualIconComponent isActive={isActive} fill={brandColor} />,
    },
    {
      label: "Insights",
      icon: (isActive: boolean) => <InsightIcon isActive={isActive} fill={brandColor} />,
    },
    {
      label: "Experience",
      icon: (isActive: boolean) => (
        <ExperienceIconComponent isActive={isActive} fill={brandColor} />
      ),
    },
  ];

  return (
    <CommentLayout
      commentLayoutId="interactive-proposal-solution "
      className={`border border-1 shadow-xl rounded-md h-[calc(100vh-111px)] ${
        isDarkTheme ? "dark-theme" : ""
      }`}
      style={
        {
          "--theme-primary-color": isDarkTheme ? secondaryColor : primaryColor,
          "--theme-inactive-color": "#8A8AA3",
        } as React.CSSProperties
      }
    >
      <div className="p-4">
        <h2 className="text-xl font-semibold mb-3 text-gray-700 conthrax-font">Solutions</h2>

        {/* Tabs and Content Container */}
        <div className="flex">
          {/* Tabs */}
          <div className="flex flex-col w-48 h-11rem gap-3 mr-4">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className={`tab-item flex rounded-md conthrax-font ${
                  activeIndex === index ? "active" : ""
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {typeof tab.icon === "string" ? (
                  <i className={`${tab.icon} mr-2`} />
                ) : (
                  tab.icon(activeIndex === index)
                )}
                {tab.label}
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="flex-1">
            <CommentLayout
              commentLayoutId={`interactive-proposal-solution-tab-${activeIndex}`}
              className="text-gray-700"
            >
              {activeIndex === 0 && <VisualTab />}
              {activeIndex === 1 && (
                <InteractiveProposalSolutionInsights isDarkTheme={isDarkTheme} />
              )}
              {activeIndex === 2 && <ExperienceTab isIntReactiveRevCent={isIntReactiveRevCent} />}
            </CommentLayout>
          </div>
        </div>
      </div>
    </CommentLayout>
  );
};

export default InteractiveProposalSolution;
